export default "__VITE_ASSET__BtVm7vTP__"